<template lang="pug">
table-base.study-list-table(:data-role='userRole')
  //- ヘッダー部
  table-row-base.study-list-table__row-header.text-medium
    table-header-base.study-list-table__row-header__cell.align-left
      slot(name='titleHeader')
    table-header-base.study-list-table__row-header__cell.align-center
      slot(name='candidateHeader')
    table-header-base.study-list-table__row-header__cell.align-center(v-if='isAdmin')
      slot(name='detailHeader')
  template(v-for='list in studyLists')
    //- 見出し部
    table-row-base.study-list-table__row-subhead.text-medium.font-bold
      table-data-base.study-list-table__row-subhead__cell(:colspan='colCount')
        .study-list-table__row-subhead__cell__text
          .study-list-table__row-subhead__cell__text__label
            slot(name='subheadYearLabel')
          .study-list-table__row-subhead__cell__text__value {{ list.year }}
          .study-list-table__row-subhead__cell__text__label
            slot(name='subheadMonthLabel')
          .study-list-table__row-subhead__cell__text__value {{ list.month }}
    template(v-for='group in list.groups')
      //- 一覧表示部
      table-row-base.study-list-table__row.text-small.font-medium
        table-data-base.study-list-table__row__cell
          .study-list-table__row__cell__text
            .study-list-table__row__cell__text__label
              slot(name='titleLabel')
            .study-list-table__row__cell__text__value {{ group.title }}
        table-data-base.study-list-table__row__cell
          button-primary.study-list-table__row__cell__button(@click='candidateButtonEvent(group.managementItem)')
            slot(name='candidateButtonLabel')
        table-data-base.study-list-table__row__cell(v-if='isAdmin')
          button-primary.study-list-table__row__cell__button(@click='detailButtonEvent(group.managementItem)')
            slot(name='detailButtonLabel')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRowBase from '@/components/atoms/TableRowBase.vue'
import TableHeaderBase from '@/components/atoms/TableHeaderBase.vue'
import TableDataBase from '@/components/atoms/TableDataBase.vue'
import ButtonPrimary from '@/components/molecules/manager/ButtonPrimary.vue'
import { StudyListType } from '@/models/studyListModel'
import { UserRoles } from '@/const/UserRoles'

/**
 * テスト一覧テーブル
 */
@Component({
  components: {
    TableBase,
    TableRowBase,
    TableHeaderBase,
    TableDataBase,
    ButtonPrimary,
  },
})
export default class StudyListTable extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // テスト一覧表示情報
  @Prop()
  studyLists!: StudyListType[]

  // 詳細ボタン押下時イベント（システム管理者権限のみ）
  @Prop()
  detailButtonEvent?: Function

  // 受験設定ボタン押下時イベント
  @Prop()
  candidateButtonEvent!: Function

  // システム管理者権限であるか
  private get isAdmin(): boolean {
    return this.userRole === UserRoles.ADMIN
  }

  private get colCount(): number {
    // システム管理者権限時は3、それ以外は2つのテーブルセルを表示
    return this.isAdmin ? 3 : 2
  }
}
</script>

<style lang="stylus" scoped>
.study-list-table
  width 100%

  &__row-header,
  &__row-subhead,
  &__row
    border-bottom 1px solid var(--color-manager-list__border)

  &__row-header
    background var(--color-manager-list__background)

    &__cell
      padding 10px 20px

      &:nth-child(2)
        width 200px

      &:nth-child(3)
        width 130px

  &__row-subhead
    background var(--subhead-background)

    &__cell
      padding 10px 20px
      color var(--color-manager-list-subhead__text)

      &__text
        display flex

        &__value
          margin-right 5px

  &__row
    background var(--color-manager-list__background)
    height 55px

    &__cell
      padding 0 20px

      &__text
        display flex

      &__button
        padding 10px 0

    &:hover
      background var(--color-manager-list__hover)

  &[data-role='admin']
    --subhead-background var(--color-manager-list-subhead-admin__background)
  &[data-role='academy']
    --subhead-background var(--color-manager-list-subhead-academy__background)
  &[data-role='branch']
    --subhead-background var(--color-manager-list-subhead-branch__background)
</style>
